function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#1583C7",
  rx: 2.462
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.725 15.188c-.362.462-.925.75-1.55.75A1.98 1.98 0 0 1 5.2 13.962a1.98 1.98 0 0 1 1.975-1.974c.588 0 1.125.262 1.487.675l.738-.938a3.138 3.138 0 0 0-2.225-.925A3.16 3.16 0 0 0 4 13.963a3.158 3.158 0 0 0 3.163 3.162c.874 0 1.662-.35 2.237-.925l-.675-1.012zm1.312-4.263h1.337v6.138h-1.337zm7.288.025h1.337v6.138h-1.337zm-2.288 6.175c-1.15 0-1.425-.975-1.45-1.537h-.012v-3.5H12.4v-1.125h1.175V9.774l1.188-.725-.038.913v1h1.2v1.125h-1.2V15.2c-.012.038-.012.088-.012.138 0 .05 0 .087.012.137v.075c.05.275.225.5.475.6a.823.823 0 0 0 .938-.225c.037-.038.062-.088.087-.125.013-.038.037 1.325-1.188 1.325z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.738 15.188v.262c-.013-.037-.013-.087-.013-.137 0-.038 0-.088.013-.126zm-.175-8.076a6.525 6.525 0 0 0-5.438 2.9h1.888a5.074 5.074 0 0 1 3.537-1.45 5.02 5.02 0 0 1 3.537 1.45H20a6.57 6.57 0 0 0-5.438-2.9z"
})));

var SvgIcCiti = function SvgIcCiti(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCiti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_citi.0b8a43f5.svg";
export { ForwardRef as ReactComponent };